import { TYPEFORM_LINK } from 'sly/b2b/constants';
import { eventNames, useEvents } from 'sly/services/events';

export default function ProviderIndexHeader() {
  const { events } = useEvents();
  const handleClick = () => {
    if (location)
      events.track(eventNames.ButtonClicked, {
        text: 'Schedule call in header',
        location: 'B2B provider page',
      });
    window.open(TYPEFORM_LINK, '_blank');
  };
  return (
    <header className='provider-gradiant m-4 flex flex-col items-center rounded-xl py-12 px-6 md:p-0'>
      <div className='flex flex-col items-center justify-end gap-4 md:max-w-5xl md:p-20'>
        <div className='flex flex-col items-center justify-end gap-4 md:w-[680px]'>
          <div className='flex self-stretch sm:justify-center '>
            <section className='font-t-xxl text-center sm:w-[400px]'>
              More connecting. Less cold-calling.
            </section>
          </div>
          <section className='font-b-l text-center'>
            Together with our parent company, CareScout, we&apos;re dedicated to
            improving the long-term care experience for everyone—including
            providers. Our mission is to simplify and dignify the aging
            experience and create a long-term care system where everyone wins.
          </section>
          <hr />
        </div>
        <button
          className='provider-cta self-stretch sm:self-auto'
          onClick={handleClick}
        >
          <p className='font-t-m-azo-xs text-white'>Schedule a call</p>
        </button>
      </div>
    </header>
  );
}
